import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'switch-field',
  imports: [CommonModule],
  templateUrl: './switch-field.component.html',
  styleUrl: './switch-field.component.scss'
})
export class SwitchFieldComponent {
  @Input() isChecked!: boolean;
  @Input() message!:string
  @Input() readonly!:boolean
  @Input() item: any;
  @Input() primaryBackground: boolean = false;
  @Output() isCheckedChange = new EventEmitter<boolean | { isChecked: boolean; item: any }>();
  @Output() valueChange = new EventEmitter<boolean>();

constructor(){}

  toggleSwitch() {    
    this.isChecked = !this.isChecked;
    if (this.item) {
      this.isCheckedChange.emit({ isChecked: this.isChecked, item: this.item });
    } else {
      this.isCheckedChange.emit(this.isChecked);
    }
    this.valueChange.emit(this.isChecked);
  }
}

